import React from "react"
import styled from "styled-components"

import { graphql, StaticQuery } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import { items } from './data/arquitetura'
import Line from './line'
import Screenshot from './images/screenshot'
import Arrow2 from './../../svgs/arrow2.svg'

const Container = styled.div`
  padding-top: 240px;
  z-index: 0;
  margin-top: -110px !important;
  @media(max-width: 919px) {
      margin-top: -80px !important;
      padding-top: 120px;
     
  }
   
`
const Items = styled.ul`
  list-style: none;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  width: 100%;
  gap: 3.2rem;
  color: var(--cPrimary);
  padding-left: 0;
  margin-top: 120px;
  margin-bottom: 150px;
  position: relative;
  @media(max-width: 919px) {
    margin-top: 60px;
    margin-bottom: 0;
  }

`

const ItemTitle = styled.h4`
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 1.2rem;
  margin-top: 0;
  line-height: 1;

  @media(max-width: 919px) {
    text-align: center;
  }
`
const Item = styled.li`
  display: flex;
  position: relative;
  width: 220px;
  max-width: 100%;
  color: #FFF;
  @media(max-width: 919px) {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
  i {
    margin-top: 10px;
    font-size: 30px;
    margin-right: 26px;
    color: var(--cPrimaryLight);

  @media(max-width: 919px) {
    font-size: 2rem;
    margin-right: 0;
  }
  }
`

const ItemDescription = styled.p`
   font-weight: 300;
    font-size: 1rem;
    line-height: 22px;
    margin-top: 14px;
    max-width: 100%;
  @media(max-width: 919px) {
    text-align: center;
  }
  
`
const ItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const Title = styled.h2`
  font-size: 2rem;
  color: #FFF;
  text-align: center;
  @media(max-width: 919px) {
    
    font-size: 1.4rem;
  }
  span {
    /* margin-left: 27px; */

    @media(max-width: 919px) {
      margin-left: 0;
    }
  }
  strong {
    line-height: 1;
    font-size: 7.5rem;
    @media(max-width: 919px) {
      font-size: 3.5rem;
    }
    color: var(--cPrimaryLight);
  }

`

const ImgWrapper = styled.div`
 margin: 0 auto;
  margin-top: 80px;
  transform: translateY(1px);
  max-width : 1316px;
 
  @media (min-width:523px) and (max-width: 791px){
    
    margin-top: 250px;
  }
`

const ArrowWrapper = styled.div`
  transform: rotate(90deg) translateX(50%);
  position: absolute;
  width: 100%;
  display: none;
  @media (min-width:523px) and (max-width: 791px){
    display: block;
  }
`

const BackgroundSection = ({ className, handle }) => (
  <StaticQuery
    query={graphql`
      query {
        desktop: file(relativePath: { eq: "element.png" }) {
          childImageSharp {
            fluid(maxWidth: 1663, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => {
      const sources = [
        // data.desktop.childImageSharp.fluid,
        {
          ...data.desktop.childImageSharp.fluid,
          media: `(min-width: 920px)`,
        },
      ]
      return (
        <BackgroundImage
          Tag="section"
          className={className}
          fluid={sources}
          fadeIn={false}
        >
         <section className="mSection">
            <div className="container" id="arquitetura" data-aos='fade-right' data-aos-duration="600">
                <Title><span>Tecnologia de ponta</span> <br /><strong>Arquitetura</strong></Title>
                
                <div>
                <Items data-aos='fade-right' data-aos-duration="600">
                  <ArrowWrapper>
                    <Arrow2 />
                  </ArrowWrapper>
                  
                  {items.map(item =>
                    <Item key={item.key}>
                    <i className={item.icon} />
                      
                      <ItemWrapper>
                        
                          <ItemTitle>{item.title}</ItemTitle>
                          <Line width="10px" color="#2D6DD8" align="flex-start" />
                          <ItemDescription>{item.description}</ItemDescription>
                        </ItemWrapper>
                    </Item>
                  )}
                </Items>
               
                </div>
              
            
            </div>
          </section>
        </BackgroundImage>
      )
    }}
  />
)


const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  height: 100%;
  background-position: top center;
  background-position-y: 30px;
  background-position-x: -280px;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 1;
  padding-bottom: 0;
  @media(max-width: 919px){
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-items: center;
    background-position-y: -200%;
    background-position-x: -3000px;
  }

  &::after, &::before {
    opacity: 1 !important;
  }

`
const Novidades = ({ handle }) => (
  <Container className="mSection bgPrimaryDark" style={{marginTop: 0, marginBottom: 0}}>
   <StyledBackgroundSection handle={handle} />
    <ImgWrapper data-aos='fade-up' data-aos-duration="600">
    <Screenshot />
      
    </ImgWrapper>
  </Container>
 )
export default Novidades
